import React from 'react'
import {Checkbox, Collapse, List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconFolderButton from "components/button/WorkableIconFolderButton";

const useStyle = makeStyles(theme => ({
    root: {},
    checkbox: {
        padding: "0 11px"
    },
    attachmentIcon: {
        position: "absolute",
        fontSize: "1.3rem"
    },
    attachmentsCount: {
        marginLeft: theme.spacing(2),
        fontWeight: "bold"
    },
    list: {
        marginLeft: theme.spacing(3)
    },
    line: {
        borderBottom: "solid 1px " + theme.palette.border.dark
    },
    italic: {
        fontStyle: 'italic'
    }
}))

const FileTypes = {
    CASE: "CASE",
    FILE: "FILE"
}

function EzdpuwList(
    {
        documents,
        toggleSelectFile,
        toggleExpandCase,
        selectedFileMap,
        level = 0,
        workingCase
    }) {
    const classes = useStyle();
    const toggleCheckbox = (e, file) => {
        e.stopPropagation();
        if (file.type === FileTypes.FILE)
            toggleSelectFile(file);
    }

    if (documents && documents.length === 0) {
        documents = [{id: "id", name: <span className={classes.italic}>{Tr(level === 0 ? "no_cases_associated" : "no_files_in_directory")}</span>, type: FileTypes.EMPTY, attachments: null}]
    }

    return (
        <List
            className={classes.list}
            component="div"
            dense
        >
            {
                documents.map(x => {
                    const hasExpand = x.type === FileTypes.CASE;
                    const expanded = x.attachments !== null

                    return (<div key={x.id}>
                        <ListItem disableRipple button onClick={hasExpand ? () => toggleExpandCase(x) : (e) => toggleCheckbox(e, x)}>
                            <ListItemIcon>
                                {x.type === FileTypes.FILE && <Checkbox
                                    className={classes.checkbox}
                                    edge="start"
                                    checked={selectedFileMap.has(x.id)}
                                    tabIndex={-1}
                                    disableRipple
                                    onClick={(e) => toggleCheckbox(e, x)}
                                />}
                                {x.type === FileTypes.CASE && <WorkableIconFolderButton working={workingCase === x.id} disabled={false}/>}
                            </ListItemIcon>
                            <ListItemText
                                primary={x.name}
                            />
                            {hasExpand ? expanded ? <UnfoldLessIcon/> : <UnfoldMoreIcon/> : null}
                        </ListItem>
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                            {expanded &&
                                <EzdpuwList
                                    toggleSelectFile={toggleSelectFile}
                                    toggleExpandCase={toggleExpandCase}
                                    selectedFileMap={selectedFileMap}
                                    documents={x.attachments}
                                    level={level + 1}
                                />}
                        </Collapse>
                        {level === 0 && <div className={classes.line}></div>}
                    </div>)
                })}
        </List>)
}

EzdpuwList.propTypes = {
    documents: PropTypes.array
}

export default EzdpuwList;